module.exports = __webpack_public_path__ + "img/LUB00298.30088983.png";